module.exports = __webpack_public_path__ + "img/decorated_eggs.a6b6d438.jpg";